import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Users/tommy/development/olsera/frontend-olsera-onlinereservation/node_modules/css-loader/dist/runtime/api.js'
import '/Users/tommy/development/olsera/frontend-olsera-onlinereservation/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Users/tommy/development/olsera/frontend-olsera-onlinereservation/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

import beachClub from '~root/src/App.vue?shadow'
window.customElements.define('beach-club', wrap(Vue, beachClub))